import { companyApi } from "@/core/apis";

// getter types
export const COMPANIES = "companies";

// action types
export const GET_COMPANIES = "getCompanies";

// mutation types
const SET_COMPANIES = "setCompanies";

const state = {
  companies: []
};

const getters = {
  [COMPANIES](state) {
    return state.companies;
  }
};

const actions = {
  [GET_COMPANIES](context) {
    return new Promise(resolve => {
      companyApi.getAllCompany().then(response => {
        context.commit(SET_COMPANIES, response);

        resolve();
      });
    });
  }
};

const mutations = {
  [SET_COMPANIES](state, companies) {
    state.companies = companies;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
